export class ErrorMessage {
    message: string;
    title: string;
    statusCode: string;
    error: {
      message: string;
    };
}
